import React from 'react'

import PriceDetails from 'tripPlanner/components/ItemOfferPrice/PriceDetails'

interface Props {
  view: App.ExperienceBookingView
  currencyCode: string
}
function ExperienceBookmarkCardPriceDetails({
  view,
  currencyCode,
}: Props) {
  return (
    <PriceDetails
      price={view.price}
      discount={0}
      priceLabel="From"
      totalLabel=""
      discountDisplayType="none"
      currencyCode={currencyCode}
    />
  )
}

export default ExperienceBookmarkCardPriceDetails
